export const EXECUTION_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};
export const SUGGESTION_TYPES = {
  CONTENT: 'content',
  SEGMENT_ACTIVATION: 'segmentActivation',
  PRE_GENERATED_VARIANTS: 'preGeneratedVariants'
};